import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RootState } from "../redux/store";
import { useSelector } from "react-redux";
import { PermissionRequirement, canAccess } from "../utils/permissions";

type Props = PropsWithChildren<{
  permission?: PermissionRequirement;
}>;

const ProtectedRoute = ({ children, permission }: Props) => {
  const { isLoggedIn, userData } = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();
  const isAllowed = canAccess(userData, permission);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login", { replace: true });
      return;
    }
    if (!isAllowed) {
      navigate("/403", { replace: true });
    }
  }, [isAllowed, isLoggedIn, navigate]);

  if (!isLoggedIn || !isAllowed) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
